module.exports = __webpack_public_path__ + "img/36.240a3be7.jpg";